import type { ConfigType } from '@plone/registry';
import { socialNetworksWidgetValidator } from '../validators/SocialNetworksWidgetValidator';

export default function installValidators(config: ConfigType) {
  config.registerUtility({
    type: 'validator',
    name: 'social_networks_widget',
    dependencies: { widget: 'social_networks_widget' },
    method: socialNetworksWidgetValidator as any,
  });
  return config;
}
